import { connect } from "react-redux";

var DropDownOptions = require("components/utility/DropDownOptions");
var LoadingButton = require("components/utility/LoadingButton");
var CurrentUser = require("lib/account/CurrentUser");

var RosterActions = require("lib/actions/RosterActions");

@connect(
	(state, props) => ({
		defaultGradeLevel: parseInt(CurrentUser.get().grade_level)
	}),
	(dispatch, props) => ({
		// creates new student list
		postStudentLists: (studentLists) => {
			var embeds = ["student_list.students,student_list.primary_admin,admin.email,student_list.passphrase,student_list.prefs"]
			return dispatch(RosterActions.postStudentLists({ studentLists, embeds }))
		},

	})
)

class AddRosterClasses extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			studentLists: _.times(3, () => ({ name: "", grade_level: props.defaultGradeLevel })),
			loading: false
		};
	}

	// filters out empty input rows
	// creates new student list
	// sends user result message
	submitClass(e) {
		$wr.nope(e)
		this.setState({ loading: true })
		var filteredStudentLists = _.filter(this.state.studentLists, (sl) => { return !_.isEmpty(sl.name) })

		var names = _.pluck(filteredStudentLists, 'name')
		var grade_levels = _.pluck(filteredStudentLists, 'grade_level')

		var params = { name: names, grade_level: grade_levels }
		this.props.postStudentLists(params).then(response => {
			this.setState({ loading: false })
			if (!response.errors) {
				var classNumber = response["student_lists"].length;
				var title = "New " + $wr.pluralize("class", classNumber, "classes") + " added";
				var text = "You have successfully created " + classNumber + $wr.pluralize(" class", classNumber, " classes") + "!";

				this.props.addStudentLists(response["student_lists"]);

				window.wrNotifications.triggerDropDownNotification({
					title: title, text: text, icon: "ok-circle"
				}, 4000);
			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response.error, icon: "exclamation-sign", type: "error"
				});
			}
		});
	}

	setValue(setIndex, key, value) {
		this.setState({
			studentLists: this.state.studentLists.map((studentList, index) => {
				if (index === setIndex) {
					return {
						...studentList,
						[key]: value
					}
				} else {
					return studentList;
				}
			})
		})
	}

	addClassRow() {
		this.setState({
			studentLists: this.state.studentLists.concat([{
				name: "", grade_level: this.props.defaultGradeLevel
			}])
		})
	}

	removeClassRow(removeIndex) {
		this.setState({
			studentLists: this.state.studentLists.filter((studentIndex, index) => {
				return removeIndex != index;
			})
		});
	}

	render() {
		var anyWithName = false;
		var classRows = this.state.studentLists.map((studentList, index) => {
			if (studentList.name.trim().length) {
				anyWithName = true;
			}

			return (
				<div key={index} className="classRow">

					<input className="form-control nameCol"
						value={studentList.name}
						onChange={(e) => this.setValue(index, "name", e.target.value)} />

					<select className="form-control gradeLevelCol"
						onChange={(e) => this.setValue(index, "grade_level", e.target.value)}
						value={studentList.grade_level}>
						{DropDownOptions.Select.GradeLevels()}
					</select>

					<button type="button"
						className="btn btn-link removeLink"
						disabled={this.state.studentLists.length < 2}
						onClick={() => this.removeClassRow(index)}>
						<span className="glyphicon glyphicon-minus-sign"></span>
					</button>

				</div>
			)
		});

		return (
			<div className="addRosterClasses">
				<form onSubmit={this.submitClass} className="addNewClassForm">
					<p className="colHeader nameCol">Class Name</p>
					<p className="colHeader gradeLevelCol">Grade</p>
					{classRows}

					<div className="text-right">
						<button type="button" className="btn btn-link addLink" onClick={this.addClassRow}>
							Add Class <span className="glyphicon glyphicon-plus-sign" />
						</button>
					</div>

					<LoadingButton className="buttonSuccess center-block"
						text="Add Classes"
						disabled={!anyWithName}
						loading={this.state.loading} />
				</form>
			</div>
		);
	}
};

AddRosterClasses.WrappedComponent.propTypes = StrictPropTypes({
	addStudentLists: PropTypes.func,
	defaultGradeLevel: PropTypes.number,
	loading: PropTypes.bool,
	postStudentLists: PropTypes.func,
});

module.exports = AddRosterClasses;


// WEBPACK FOOTER //
// ./modules/components/org/roster/AddRosterClasses.js